import { Input } from '@app/components';
import { Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { QRCodeFormSchema } from '../../api/qr-code.form.schema.api';
import { EBulkMode, useBulkQueryParam } from '@app/domain/plan/components/bulk-button/useBulkQueryParam.hook';
import { QRCodeContainer } from '../QRCodeContainer';
import { QRCodeOutDtoOverridden } from '../../qr-code.types';

export const QRCodeDoneStep: React.FC<{
  qrCodes?: QRCodeFormSchema[];
}> = ({ qrCodes }) => {
  const { t } = useTranslation();
  const { control, trigger } = useFormContext<QRCodeFormSchema>();

  const [bulkMode] = useBulkQueryParam(EBulkMode.NONE);
  const isBulkMode = bulkMode === EBulkMode.BULK_WEBSITE;

  if (isBulkMode && qrCodes) {
    const qrs = qrCodes as unknown as QRCodeOutDtoOverridden[];
    return (
      <div className="h-full space-y-6 bg-white px-5 py-6 xl:rounded-xl">
        <Typography className="font-bold sm:text-l">{t('qr.stepDone.almostReady')}</Typography>
        <div className="flex flex-col gap-2">
          {qrs.map((qrCode) => (
            <QRCodeContainer key={qrCode.name} qrCode={qrCode} isPreviewMode />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="h-full space-y-6 bg-white px-5 py-6 xl:rounded-xl">
      <Typography className="font-bold sm:text-l">{t('qr.stepDone.almostReady')}</Typography>
      <Controller
        name="name"
        control={control}
        render={({ field: { value, onChange, ...field }, fieldState }) => (
          <Input
            {...field}
            onChange={(e) => {
              onChange(e);
              if (fieldState?.error?.message) {
                trigger('websiteUrl');
              }
            }}
            value={value || ''}
            label={t('qr.stepDone.enterNameForYourQRCode')}
            withBG
            errorMessage={fieldState?.error?.message || ''}
          />
        )}
      />
    </div>
  );
};
